import styled from 'styled-components';

export const CardGridWrapper = styled.div`
  display: grid;
  grid-template-areas: 'detail';
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  padding: .5rem;
  overflow: hidden;
`;
